import apiClient from '../authentication/utils/core/axios';

/**
 * MeetingNotesAPI — admin-only CRUD for the meeting-notes/decision log,
 * built to sit next to RoadmapAPI (roadmapApi.js): a note records what was
 * discussed/decided, and can link to the real roadmap items it affects.
 */
const MeetingNotesAPI = {
  fetchNotes: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.flaggedOnly) query.append('flagged_only', 'true');
    if (params.tag) query.append('tag', params.tag);
    if (params.search) query.append('search', params.search);
    // 30s, not the client default (15s) -- the Admin Dashboard fires several
    // concurrent admin-data requests on load against this app's single
    // backend worker (WEB_CONCURRENCY=1, a deliberate memory-constrained
    // tradeoff, see 13_FIX_HISTORY.md's twelfth pass), so a request queued
    // behind others can legitimately take 10-20s to actually run even
    // though it succeeds. Confirmed live: a direct fetch returned a correct
    // 200 in 11.3s; the 15s default timeout was firing "Request timed out"
    // on an otherwise-working call. 30s matches Gunicorn's own worker
    // timeout, so the client never gives up before the server would.
    const res = await apiClient.get(`/admin/meeting-notes/?${query.toString()}`, { timeout: 30000 });
    return res.data;
  },

  createNote: async (noteData) => {
    const res = await apiClient.post('/admin/meeting-notes/', noteData);
    return res.data;
  },

  updateNote: async (noteId, updates) => {
    const res = await apiClient.patch(`/admin/meeting-notes/${noteId}`, updates);
    return res.data;
  },

  deleteNote: async (noteId) => {
    await apiClient.delete(`/admin/meeting-notes/${noteId}`);
    return noteId;
  },
};

export default MeetingNotesAPI;
